import { useState } from 'react';
import { useQuery } from '@apollo/client';
import { CHATS_PAGE_DEFAULT } from '@arthelper/shared/chat-parts';

import { MY_CHATS_QUERY } from '~/graphql/queries';

interface MyChatsScope {
  type?: string;
  targetId?: string;
}

// One page of the viewer's chats (newest first) plus an explicit "load more". The
// Query.myChats relayStylePagination policy appends fetchMore pages; a refetch collapses to page one.
export function useMyChats(scope: MyChatsScope = {}) {
  const [loadingMore, setLoadingMore] = useState(false);
  const { data, loading, fetchMore } = useQuery(MY_CHATS_QUERY, {
    variables: { first: CHATS_PAGE_DEFAULT, ...scope },
    fetchPolicy: 'cache-and-network',
  });

  const connection = data?.myChats;
  const chats: any[] = (connection?.edges ?? []).map((edge: any) => edge.node);
  const hasNextPage = Boolean(connection?.pageInfo?.hasNextPage);

  const loadMore = () => {
    if (loadingMore || !hasNextPage) {
      return;
    }

    setLoadingMore(true);
    fetchMore({ variables: { after: connection.pageInfo.endCursor } })
      .catch((err) => {
        console.error('Error loading more chats:', err);
      })
      .finally(() => {
        setLoadingMore(false);
      });
  };

  return { chats, loading, hasNextPage, loadMore, loadingMore };
}
